(function (angular) {
    'use strict';

    angular.module('dashboard')

        /**
         *
         */
        .factory('blogService',
            ['$http', '$q', 'themeService', function ($http, $q, themeService) {

                var fac = {

                    getFeed: function () {

                        var blogFeed = themeService.getThemeInfo().rssFeedUrl;

                        var qs = blogFeed ? ("?feed=" + encodeURIComponent(blogFeed)) : "";

                        return $http.get("/blogs" + qs)
                            .then(getFeedComplete)
                            .catch(getFeedFailed);

                        function getFeedComplete(response) {
                            return response.data;
                        }

                        function getFeedFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                };

                return fac;

            }]);

})(window.angular);
